export const removeAllJavascriptFiles = (htmlNode: HTMLElement) => {
  const scriptTags = htmlNode.querySelectorAll("script");
  if (!scriptTags.length) return Promise.resolve(htmlNode);

  return Promise.resolve().then(() => {
    scriptTags.forEach((scriptTag) => scriptTag.remove());
    return htmlNode;
  });
};
